import styles from './Footer.module.scss';
import { Flex, Image, Text } from '@chakra-ui/react';
import DurinLogo from '../assets/logo.png';

const Footer = () => {
    return (
        <Flex
            as="footer"
            className={styles.footer}
            align="center"
            justify="center"
            px={[4, 8, 12]}
            py={[6, 8]}
            bg="gray.50"
            borderTop="1px solid"
            borderColor="#e9e9e9"
            direction="column"
            gap={[3, 4]}
        >
            <Image
                src={DurinLogo}
                alt="Logo"
                className={styles.logo}
                h={["28px", "32px"]}
                onClick={() => window.open('https://www.durin.com', '_blank', 'noopener,noreferrer')}
                cursor="pointer"
            />
            <Text
                fontSize={["xs", "sm"]}
                color="gray.600"
                textAlign="center"
                px={[2, 0]}
            >
                © {new Date().getFullYear()} Durin. All rights reserved.
            </Text>
        </Flex>
    );
};

export default Footer;
